import http from "./HttpService";
import {
  LOGIN,
  RESET_PASSWORD,
  SUPPORT_EMAIL,
  SIGNUP,
  SET_NEW_PASSWORD,
  GET_CSRF_FROM_OTP,
  API_BASE_CONTENT,
  LOGOUT,
  API_BASE_AUTH,
} from "../../constants/index";
import { getAccessId, getCSRFToken } from "utils";

export async function login(data: FormData) {
  return await http.post(LOGIN, data);
}
export async function signup(data: FormData) {
  return await http.post(SIGNUP, data);
}

export async function resetPassword(data: FormData) {
  return await http.post(RESET_PASSWORD, data);
}

export async function forgetUsername(data: FormData) {
  return await http.post(SUPPORT_EMAIL, data);
}

export async function setNewPassword(data: FormData) {
  return await http.post(SET_NEW_PASSWORD, data);
}

export async function getCsrfTokenFromOtpService(otp?: string) {
  const access_id = getAccessId();
  const headers = {
    "X-CSRFToken": otp,
    authorization: `Bearer ${access_id}`,
  };
  return await http.post(GET_CSRF_FROM_OTP, {}, { headers, withCredentials: true });
}

export function setHideFirstTimeMessageAmazingServices() {
  return http.post("");
}

export function getUserDataService() {
  return http.get(`${API_BASE_CONTENT}user_data/`, { headers: { "X-CSRFToken": getCSRFToken() } });
}

export function getAccountDetailsService() {
  const payload = new FormData();
  payload.append("appName", "workbench-s");
  return http.post(`${API_BASE_AUTH}profile_login/`, payload, { headers: { "X-CSRFToken": getCSRFToken() } });
}

export function setDoNotShowPopupAgainService() {
  const payload = new FormData();
  payload.append("key", "show_msg");
  payload.append("show_msg", "0");
  return http.post(`${API_BASE_CONTENT}user_data/`, payload, { headers: { "X-CSRFToken": getCSRFToken() } });
}

export function setDoShowPopupAgainService() {
  const payload = new FormData();
  payload.append("key", "show_msg");
  payload.append("show_msg", "1");
  return http.post(`${API_BASE_CONTENT}user_data/`, payload, { headers: { "X-CSRFToken": getCSRFToken() } });
}

export const setOnBoardingStepService = (values: any) => {
  const payload = new FormData();
  Object.keys(values).forEach((key) => {
    payload.append(key, values[key]);
  });
  return http.post(`${API_BASE_CONTENT}user_data/`, payload, { headers: { "X-CSRFToken": getCSRFToken() } });
};

export const getUserPlanTypeService = () => {
  return http.get(`${API_BASE_CONTENT}plan_type/`, { headers: { "X-CSRFToken": getCSRFToken() } });
};

export const logoutService = (data: any) => {
  let payload = new FormData();
  Object.keys(data).forEach((key) => {
    payload.append(key, data[key]);
  });
  return http.post(LOGOUT, payload);
};
